// extracted by mini-css-extract-plugin
export var black = "Button-module--black--78126";
export var button = "Button-module--button--c19c1";
export var buttonGroup = "Button-module--buttonGroup--22b3c";
export var content = "Button-module--content--9d0cf";
export var large = "Button-module--large--c2c42";
export var loading = "Button-module--loading--2370a";
export var loadingSpinner = "Button-module--loadingSpinner--d7fdc";
export var secondary = "Button-module--secondary--2469a";
export var secondaryDark = "Button-module--secondaryDark--cfce5";
export var small = "Button-module--small--1cf37";
export var underline = "Button-module--underline--6c95d";